// TODO: placeholder copy — confirm final titles before ship
export const LEARNING_BLOCK_TITLES: string[] = [
    "Welcome to Asurion",
    "Expert Foundations",
    "Asurion Tools",
    "Client Tools",
    "Sales Foundations",
    "Call Flow Part 1",
    "Troubleshooting",
    "Device Basics",
    "Hardware vs. Software",
    "Networking",
    "Activations",
    "Carrier Account",
    "Insurance & Warranty Claims",
    "Sales in Action",
    "Call Flow Part 2",
    "Training Closing",
];

export const UNASSIGNED_GROUP_KEY = "unassigned";

export const UNASSIGNED_GROUP_LABEL = "Unassigned";

export function getLearningBlockLabel(blockNumber: number): string {
    const title = LEARNING_BLOCK_TITLES[blockNumber - 1];
    if (title === undefined) {
        return `Learning Block ${blockNumber}`;
    }
    return `Learning Block ${blockNumber}: ${title}`;
}
